var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLoginController',_vm._b({attrs:{"mfaType":_vm.mfaType,"paramError":_vm.error,"step":_vm.step}},'UserLoginController',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }